import { render } from "./Shoesandsandles.vue?vue&type=template&id=ce2f10e8"
import script from "./Shoesandsandles.vue?vue&type=script&lang=js"
export * from "./Shoesandsandles.vue?vue&type=script&lang=js"

import "./Shoesandsandles.vue?vue&type=style&index=0&id=ce2f10e8&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__